import { Observable } from 'rxjs'

export abstract class MbCheckoutAdapter {

  abstract redirectToPaymentPage(userId: string, cartId: string, termsChecked: boolean): Observable<any>

  abstract placeOrderWithPayment(
    userId: string,
    cartId: string,
    returnMac: string,
    hostedCheckoutId: string): Observable<any>

  abstract resetIngenicoPayment (userId: string, cartId: string): Observable<any>
}
